module.exports = __webpack_public_path__ + "static/media/DangerSignIcon.28b31e92.svg";